<template lang="html">
  <section class="filter-list-edit">
    <name-input
      :all-des="allDes"
      :is-ready="true"
      :name="storedDataElement.name"
      :should-focus="!storedDataElement.name"
      :de-id="storedDataElement.id"
      @on-name-input-changed="onDeNameChanged"
    ></name-input>

    <element-description
      :elem-description="storedDataElement.description"
      @on-element-description-changed="onDeDescriptionChanged"
    ></element-description>

    <div class="row-container">
      <label class="query-label">
        {{ getMessageText(messages.DATA_SOURCE) }}
      </label>
      <div class="ds-select">
        <search-box-simple
          id="searchDatasource"
          :list="sourceList"
          :value="selectedSourceValue"
          @on-search-box-item-selected="onSourceSelected"
        />
      </div>
    </div>

    <div class="row-container" v-if="hasSelectedSource">
      <label class="query-label fields-label">
        {{ getMessageText(messages.FILTER_BY) }}
      </label>
      <div class="ds-select">
        <expressions
          id="filterlistby"
          :data-elements="allDes"
          :selected-source="selectedSource"
          :data-type="'bool'"
          :initial-expression="filterValue"
          :content-type="appType"
          @on-expression-field-valid="onConfigExpressionValid"
        />
      </div>
    </div>
  </section>
</template>

<script lang="js">
  import { mapState, mapActions } from "vuex";
  import { MUTATION_NAME } from "@/static/global-variables";
  import expressionBuilder from "@/views/drag-drop-pages/components/utils/expression-builder";
  import SearchBoxSimple from "@/components/SearchBoxSimple";
  import Expressions from "@/components/Expressions"
  import NameInput from "@/components/NameInput";
  import ElementDescription from "@/components/ElementDescription";

  export default  {
    name: "filter-list-edit",
    components: {
      SearchBoxSimple,
      Expressions,
      NameInput,
      ElementDescription
    },
    props: {
      appId: {
       type: String
      },
      allDes: {
        type: Object
      },
      de: {
        type: Object
      },
      appType: {
        type: String
      }
    },
    computed: {
      ...mapState({
        messages: "messages"
      }),
      selectedSource() {
        return this.storedDataElement.selectedSource;
      },
      filterValue() {
        return this.storedDataElement.filter && this.storedDataElement.filter.type?
            this.storedDataElement.filter : null;
      },
      sourceList() {
        return this.dataSources.map(e => {
          e.label = e.name;
          return e;
        });
      },
      selectedSourceValue() {
        return this.sourceList.find(e => e.id === this.de.original);
      },
      dataSources() {
        delete this.allDes[this.de.id];
        return expressionBuilder.filterGlobalSources(this.allDes);
      },
      hasSelectedSource() {
        return Boolean(this.storedDataElement.selectedSource);
      }
    },
    watch: {
      selectedSourceValue: {
        /* Resetting the initial state when the element is loaded, called only once */
        handler: function() {
          this.storedDataElement.selectedSource = this.selectedSourceValue;
          if(this.de.filter && this.de.filter.type) {
            this.storedDataElement.filter = this.de.filter;
            this.storedDataElement.filter.status = true;
            this.storedDataElement.filter.valid = true;
            this.setDataElement(this.storedDataElement);
          }
        },
        deep: true,
        immediate: true
      }
    },
    data () {
      return {
        storedDataElement: {
          name: this.de.name,
          description: this.de.description,
          type: "DATA_EL_FILTER_LIST",
          selectedSource: null,
          filter: null
        }
      }
    },
    methods: {
      ...mapActions({
        setDataElement: MUTATION_NAME.SET_EDIT_DATA_ELEMENT
      }),
      onSourceSelected(val) {
        this.storedDataElement.filter = null;
        this.storedDataElement.selectedSource = val.isEmpty? null : val;
        this.setDataElement(this.storedDataElement);
      },
      onConfigExpressionValid(ctx) {
        this.storedDataElement.filter = ctx.confExpression;
        this.storedDataElement.filter.valid = ctx.status;
        this.setDataElement(this.storedDataElement);
      },
      onDeNameChanged(isValidName, nameInput) {
        this.storedDataElement.name = nameInput;
        this.$emit("on-de-name-changed", isValidName);
        this.setDataElement(this.storedDataElement);
      },
      onDeDescriptionChanged(input) {
        this.storedDataElement.description = input;
        this.setDataElement(this.storedDataElement);
      }
    }
  }
</script>

<style scoped lang="scss">
  .filter-list-edit {
    min-height: 8rem;
    .row-container {
      display: flex;
      flex-direction: column;
      padding: 0 1rem;
      margin-top: 1rem;
      margin-bottom: 1rem;
      min-width: 45rem;
    }
    .query-label {
      max-width: 100px;
      padding-right: 0.5rem;
      margin-bottom: 0;
    }
    .fields-label {
      padding-top: 0.6rem;
      min-width: 6.2rem;
    }
    .ds-select {
      flex: 3;
      .filter {
        margin-bottom: 0.7rem;
      }
    }
    .btn-container {
      padding: 1rem 1rem 0;
      .add-btn {
        padding: 0;
        background: transparent;
        background-clip: border-box;
        border: 1px solid transparent;
        border-radius: 0.25rem;
        line-height: 1.875rem;
        color: #0070d2;
        -webkit-appearance: none;
        white-space: normal;
      }
    }
  }
</style>
